import PageNotFound from "@/pages/PageNotFound"
import LandingPage from "@/pages/LandingPage"

export default [
    { path: "/", redirect: "/home" },
    { path: "/home", component: LandingPage },
    { path: "*", component: PageNotFound }
]
